export default __webpack_public_path__ + "images/8784d4ade2f386d9ad19c3434f17d388.svg";